// Widget-Plugin: Heatmap
vcDashboardRegistry.register("heatmap", {
    defaults: { w: 20, h: 12, resizable: true, copyable: true, showSettings: true, openSettingsOnCreate: true },
    settingsDefaults: { SignalIds: [], IsCumulated: false, Interval: 0, ChartType: "heatmap", ComparisonMode: 0, ComparisonOffset: -1, PriceCo2: 0 },
    get popupTitle() { return vcDashboardResources.get("heatmapSettings"); },
    render: function ($container, item) {
        $container.html("<div class='dashboard-chart-wrapper'>" + item.title + "</div>");
    },
    buildParams: function (settings, status) {
        return vcDashboardPopup.buildChartParams(settings, status);
    },
    loadChart: function ($item, settings) {
        var resolved = vcDashboardPopup.resolveEffectiveSettings($item, settings);
        var obj = $item.find(".dashboard-chart-wrapper");
        obj.empty();
        obj.height($item.find(".dashboard-item-content").height());

        var params = this.buildParams(resolved.effectiveSettings, resolved.status);
      
        //send the config for the share url
        var p1 = {

            bsaid: (Array.isArray(resolved.effectiveSettings.SignalIds) && resolved.effectiveSettings.SignalIds.length > 0) ? resolved.effectiveSettings.SignalIds[0] : -1,
            startDate: params.Param.startDate,
            endDate: params.Param.endDate,
            interval: params.Param.interval,

            DataType: params.Param.datatype,
            LoggerId: resolved.effectiveSettings.LoggerId,
            isStandAlone: false
        };

        obj.Heatmap({ parameter: p1 });



    },
    onLoad: function ($item, settings) {
        this.loadChart($item, settings);
    },
  
    buildFields: function (currentSettings, $el) {
        var signalOptions = vcDashboardPopup.getSignalOptions($el);
        var fields = [];
        if (signalOptions.length) {
            fields.push({ key: "SignalIds", label: vcDashboardResources.get("signal"), type: "searchselect", options: signalOptions, arrayIndex: 0 });
        }
       
        fields.push({ key: "Interval", label: vcDashboardResources.get("interval"), type: "select", options: [{ value: 0, text: vcDashboardResources.get("inheritFromMenu") }, { value: 1, text: vcDashboardResources.get("singleValues") }, { value: 2, text: vcDashboardResources.get("dailyValues") }, { value: 3, text: vcDashboardResources.get("monthlyValues") }] });
        //fields.push({ key: "PriceCo2", label: vcDashboardResources.get("priceCo2"), type: "select", options: [{ value: 0, text: vcDashboardResources.get("noSelection") }, { value: 1, text: vcDashboardResources.get("prices") }, { value: 2, text: vcDashboardResources.get("co2") }] });
        return fields;
    },
    onSettingsSave: function ($el, newSettings) {
        this.loadChart($el, newSettings);
    },
    init: function ($item, settings) {
        vcDashboardPopup.initPlugin($item, this, settings);
    },
    resize: function ($item, settings) {
        this.loadChart($item, settings);
    }
});
